import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import type { FlowMediaSettingsDto } from '@/types/dtos/media/media-settings.dto';
import { patchFlowMediaSettingsEverywhere } from '@/state/mutations/media/patch-media-settings-cache';

export const usePatchFlowMediaSettingsMutation = (options?: { onSuccess?: () => void }) => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ flowId, patch }: { flowId: string; patch: Partial<FlowMediaSettingsDto> }) => {
      const token = await getToken();
      return patchFlowMediaSettings(flowId, patch, token ?? '');
    },
    onSuccess: (mediaSettings, variables) => {
      patchFlowMediaSettingsEverywhere(queryClient, variables.flowId, mediaSettings);
      options?.onSuccess?.();
    },
  });
};

const patchFlowMediaSettings = async (flowId: string, patch: Partial<FlowMediaSettingsDto>, token: string) => {
  const url = `${import.meta.env.VITE_API_URL}/flows/${flowId}/media-settings`;
  return sendJSONRequest({ url, method: METHOD.PATCH, body: patch, token });
};
